export default __webpack_public_path__ + "static/DF_2014-54252790b11bdffa9f0158769a7f191a.pdf";